import { render, staticRenderFns } from "./ClientDocumentAskingProfile.vue?vue&type=template&id=01dc7bf4&"
import script from "./ClientDocumentAskingProfile.vue?vue&type=script&lang=js&"
export * from "./ClientDocumentAskingProfile.vue?vue&type=script&lang=js&"
import style0 from "./ClientDocumentAskingProfile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports